import { Button } from "@mui/material";
import { useTranslations } from "use-intl";

import { IconTravellerCrossed } from "@/components/Icons";
import { type Traveller } from "@/types/types";

const ICON_SIZE = 60;

function DeleteTraveller({
  traveller,
  closeDrawer,
  deleteTraveller,
}: {
  traveller: Traveller;
  closeDrawer: () => void;
  deleteTraveller: () => void;
}) {
  const t = useTranslations();

  const fullName = `${traveller.firstName} ${traveller.lastName}`;
  const removeTravellerHandler = () => {
    deleteTraveller();
    closeDrawer();
  };

  return (
    <div className="flex h-full w-full flex-col items-center">
      <IconTravellerCrossed
        width={ICON_SIZE}
        height={ICON_SIZE}
        aria-hidden
        className="border-b-1 border-b-semantic-error-strong"
      />
      <h5 className="mt-6 mb-3 text-base leading-6 font-medium text-text-title">
        {t("travellers.deletePerson")}
      </h5>
      <span
        className="mb-11 text-sm font-normal text-text-placeholder"
        data-sentry-mask
      >
        {t("travellers.deleteName", {
          fullName,
        })}
      </span>
      <div className="mt-auto flex w-full flex-col gap-2">
        <Button
          onClick={removeTravellerHandler}
          variant="contained"
          color="error"
        >
          {t("delete")}
        </Button>
        <Button onClick={closeDrawer} variant="text">
          {t("cancel")}
        </Button>
      </div>
    </div>
  );
}

export default DeleteTraveller;
